
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/yoga-meditation",
      function () {
        return require("private-next-pages/[region]/[language]/yoga-meditation/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/yoga-meditation"])
      });
    }
  